<template>
  <div :class="$style.container">
    <div v-for="action in params.actions" :class="$style.button">
      <vs-button
        size="small"
        type="border"
        iconPack="feather"
        :icon="action.icon"
        :title="action.title"
        :to="action.to"
        @click="onClick(action)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name:    "AgGridActions",
  methods: {
    onClick( { action } ) {
      action && action();
    },
  },
});
</script>

<style lang="scss" module>
.container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.button {
  margin-left: .5em;
}
</style>
